export type IconType = (typeof IconTypes)[keyof typeof IconTypes];
export const IconTypes = {
  Calendar: "calendar",
  Car: "car",
  Clock: "clock",
  Experience: "experience",
  Introduction: "introduction",
  Interesting: "interesting",
  Linkedin: "linkedin",
  Logo: "logo",
  Office: "office",
  Payment: "payment",
  Person: "person",
  Pin: "pin",
  Tag: "tag",
  Translation: "translation",
  Call: "call",
  Cart: "cart",
  Close: "close",
  Search: "search",
  ArrowLeft: "arrow-left",
  ArrowRight: "arrow-right",
  ChevronDown: "chevron-down",
  Upload: "upload",
  Cross: "cross",
  Trash: "trash",
  Menu: "menu",
} as const;
